import { ApiException } from '@eta/components';
import {
    LOAD_CURRENT_PROFILE,
    SAVE_CURRENT_PROFILE,
    ProfileActionTypes,
    CANCEL_MODIFICATION,
    SAVE_CURRENT_NOTIFICATIONS,
    LOAD_CURRENT_NOTIFICATIONS,
} from './Types';
import { IGetCurrentUserDetailsQueryResponseDto } from '../../Services/ClientProxy/clientProxy';
import { GetUserPreferenceResponse } from '../../Services/ClientProxy/NotificationManagementClient';

export interface ProfileState {
    currentProfile?: IGetCurrentUserDetailsQueryResponseDto;
    currentNotification?: GetUserPreferenceResponse;
    lastError?: ApiException;
}

const initialState: ProfileState = {};

export function profileReducer(
    state = initialState,
    action: ProfileActionTypes
) {
    switch (action.type) {
        case CANCEL_MODIFICATION:
            return {
                ...state,
                currentProfile: { ...state.currentProfile },
            };
        case LOAD_CURRENT_PROFILE:
            return {
                ...state,
                currentProfile: { ...action.payload },
            };
        case SAVE_CURRENT_PROFILE:
            return {
                ...state,
                ...action.payload,
            };

        case LOAD_CURRENT_NOTIFICATIONS:
            return {
                ...state,
                currentNotification: { ...action.payload },
            };
        case SAVE_CURRENT_NOTIFICATIONS:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
}
